module.exports = __webpack_public_path__ + "static/media/icon_renafad36d4a0f48fcbba931afdfd79dce4.webp";